import { useGooleAnalytics } from '@/uComposables/analytics/gooleAnalytics'
import { isNativeShellApp } from '@/utils/appBridgeGate'

export default defineNuxtPlugin(() => {
  window.onLoginSuccess = async (data) => {
    const authStore = useAuthStore()
    const { updateLongUserAuth } = authStore

    const { refresh: refreshUserData } = useUserData()
    const { checkExternalOrder } = useExternalOrderStore()
    const { redirect } = useRedirectStore()
    const { trackLogin } = useMarketSDK()
    const { kakaoPixelPageView } = useKakaoPixel()
    const route = useRoute()

    kakaoPixelPageView('login')
    updateLongUserAuth(data.accessToken)

    const partnersKey = String(route.params.partner || '')
    if (!partnersKey && data.accountId) {
      trackLogin(data.accountId)
      useGooleAnalytics()?.sendCommonEvent()
    }

    if (data.accountCode) {
      useAirbridge()?.trackLogin(data.accountCode)
      useGooleAnalytics()?.sendCommonEvent()
    }

    checkExternalOrder()

    await refreshUserData()

    // 2.2.7 이상: 앱이 로그인 성공 후 웹뷰를 returnUrl 로 직접 이동시킴.
    // 2.2.6 이하: 앱이 이동시켜 주지 않으므로 웹이 직접 redirect (구버전 동작).
    if (!isNativeShellApp()) {
      redirect(data.isFirstLogin ?? false)
    }
  }
})
